import EventPage from './EventPage';

export default EventPage;
